module.exports = __webpack_public_path__ + "static/media/friargate-3-cropped.ff8733c9.png";